import { css } from 'glamor';

export default css({
  width: 10,
}).toString();
